import React from 'react'
import { Button, Progress, Typography } from 'antd'
import { ThreeDot } from 'react-loading-indicators'
import styles from '../AiEnhancementModal.module.scss'

interface IEnhancementProgressItem {
  title: string
  percent: number
  message: string
  error: string
  active: boolean
}

interface IEnhancementProgressProps {
  items: IEnhancementProgressItem[]
  onBack?: () => void
}

export const EnhancementProgress: React.FC<IEnhancementProgressProps> = ({
  items,
  onBack
}) => {
  const activeItems = items.filter((item) => item.active)
  const hasError = activeItems.some((item) => item.error)

  return (
    <div className={styles.progressWrapper}>
      {!hasError && <ThreeDot color='#FF7905' size='medium' text='' textColor='' />}
      {activeItems.map((item) => (
        <div key={item.title} className={styles.progressItem}>
          <div className={styles.progressTitleRow}>
            <Typography.Text strong>{item.title}</Typography.Text>
            <Typography.Text type={item.error ? 'danger' : 'secondary'}>
              {item.error || item.message}
            </Typography.Text>
          </div>
          <Progress
            percent={item.error ? 100 : item.percent}
            status={item.error ? 'exception' : 'active'}
          />
        </div>
      ))}
      {hasError && onBack && (
        <Button size='large' onClick={onBack} className={styles.progressBackButton}>
          Назад к настройкам
        </Button>
      )}
    </div>
  )
}
